export default __webpack_public_path__ + "static/media/inbound_talk_time.708c656f.svg";